<template>
  <div
    class="wrap page1 f1 df fdc noselect"
    v-bind:class="{ 'wrap-extra': !$store.getters.emailVerified }"
  >
    <div class="top-bar">
      <ProjectTop />
      <ProjectTabs v-bind:projectPage="projectPage" />
    </div>
    <ProjectPagePricing v-if="projectPage == 'pricing'" />
    <ProjectPageTasks v-else-if="projectPage == 'tasks'" data-v-step="1" />
    <ProjectPagePhases v-else-if="projectPage == 'phases'" data-v-step="2" />
    <ProjectPageTotals v-else-if="projectPage == 'totals'" data-v-step="3" />
    <v-tour
      v-if="tourEnable"
      name="projectTour"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import ProjectTop from '../project/ProjectTop'
import ProjectTabs from '../project/ProjectTabs'
import ProjectPagePricing from '../project/pagepricing/ProjectPagePricing'
import ProjectPageTasks from '../project/ProjectPageTasks'
import ProjectPageTotals from '../project/ProjectPageTotals'
import ProjectPagePhases from '../project/ProjectPagePhases'
import { mapGetters } from 'vuex'

export default {
  name: "DashboardProject",
  metaInfo() {
    return {
      title: `${this.currentProjectName} | HourPrice`
    }
  },
  data() {
    return {
      // mode: 'login' // login/register
      tourEnable: false,
      fromOldProject: false,
      tourOptions: {
        highlight: true,
        labels: {
          buttonSkip: "Skip tour",
          buttonPrevious: "Previous",
          buttonNext: "Next",
          buttonStop: "Done"
        }
      },
      tourCallbacks: {
        onFinish: this.disableTour
      },
      tourSteps: [
        {
          target: '[data-v-step="0"]', // We're using document.querySelector() under the hood
          content: `<strong>Name your project</strong><br>This is how your project will appear to people you share with and on your Projects Dashboard.`
        },
        {
          target: '[data-v-step="1"]',
          content: `<strong>Blended rate</strong><br>If you use blended rates for estimating, set them here. You can also set rates for each resource or fixed costs for each deliverable in your project.`
        },
        {
          target: '[data-v-step="2"]',
          content: `<strong>Overrides</strong><br>Add an override like project management fees or a discount that is added to the final price of your entire project.`
        },
        {
          target: ".v-step-3",
          content: `<strong>Add Roles and Resources</strong><br>Add team members or roles that will work on your deliverables.`,
          params: { enableScrolling: false }
        },
        {
          target: ".v-step-4",
          content: `<strong>Deliverables</strong><br>Add items to be completed in your project. Add notes and attachments to describe them if needed.`,
          params: { enableScrolling: false, placement: "right" }
        },
        {
          target: ".v-step-5",
          content: `<strong>Start Pricing!</strong><br>Add the cost or number of hours required to complete each deliverable.`,
          params: { enableScrolling: false, placement: "left" }
        },
        {
          target: '[data-v-step="6"]',
          content: `<strong>You're all set!</strong><br>Now that you know the basics you’re ready to start pricing your project.<br><br>
Your total price will appear here.<br><br>
Happy pricing!`,
          params: { enableScrolling: false, placement: "left" }
        }
      ]
    };
  },
  props: ["projectPage"],
  components: {
    ProjectTop,
    ProjectTabs,
    ProjectPagePricing,
    ProjectPageTasks,
    ProjectPagePhases,
    ProjectPageTotals
  },
  methods: {
    help() {
      if (
        this.$store.state.featureToggle.productTour &&
        !localStorage.getItem("tourDisabled")
      ) {
        this.startTour();
      }
    },
    disableTour() {
      localStorage.setItem("tourDisabled", "true");
    },
    startTour() {
      localStorage.removeItem("tourDisabled");
      this.$tours["projectTour"].start();
    }
  },
  computed: {
    ...mapGetters([
      'uid',
      'currentProjectFull',
      'currentProjectName'
    ]),
    role() {
      return this.uid &&
        this.currentProjectFull &&
        this.currentProjectFull.users &&
        this.currentProjectFull.users[this.uid]
    },
  },
  watch: {
    role(val) {
      if (val) {
        console.log('set user role*********', val);
        this.$store.dispatch("setUserRole", val)
      }
    }
  },
  mounted: function() {},
  async created() {
    this.$store.dispatch("loading", true)
    const projectDetail = await this.$store.dispatch("getProjectDetailsOnce", { projectid: this.$route.params.projectid })
    if (projectDetail && projectDetail.users && Object.keys(projectDetail.users).includes(this.uid) ) {
      console.log('already accepted' )
      await this.$store.dispatch("getProjectDetails", { projectid: this.$route.params.projectid })
      await this.$store.dispatch("getProjectFullDetails", { projectid: this.$route.params.projectid });
      this.$store.dispatch("initBackUpCache");
      window.scrollTo(0, 0);
    } else {
      if (this.$route.query.token) {
        const tokenData = await this.$store.dispatch("getTokenData", this.$route.query.token)
        const userData = this.$store.getters.userData
        if (userData.email === tokenData.email) {
          const data = {
            projectID: this.$route.params.projectid,
            userID: this.$store.getters.uid,
            role: tokenData.role
          };
          this.$store.dispatch("acceptProject", data)
          console.log("** Project Component Loaded", this.$route);
          await this.$store.dispatch("getProjectDetails", { projectid: this.$route.params.projectid })
          await this.$store.dispatch("getProjectFullDetails", { projectid: this.$route.params.projectid });
          this.$store.dispatch("initBackUpCache");
          window.scrollTo(0, 0);
        } else {
          console.log('no match token email')
        }
      }
    }
    this.$store.dispatch("loading", false)
  },
  beforeDestroy () {},
  destroyed () {
  }
};
</script>

<style scoped lang="scss">
.top-bar {
  position: fixed;
  width: 100%;
  z-index: 99;
}
.wrap-inner {
  /*background-image: url('/images/news-bg.svg');*/
  background-position: center;
  -webkit-background-size: contain;
  background-size: contain;
  background-repeat: no-repeat;
  /*justify-content: flex-end;*/
}
.wrap {
  width: 100%;
  /*height: calc(100% - 45px);*/
  position: absolute;
  left: 0;
  padding: 0;
  top: 45px;
}
.wrap-extra {
  height: calc(100% - 75px);
  top: 75px;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}
</style>
